/// <reference path="../pocmemberform.js" />
import React, { useEffect, useState } from 'react';
import { Alert, Col, FormControl, OverlayTrigger, Row, Tooltip } from 'react-bootstrap';
import '../../../../styles/Forms.css';
import { HHIEButton } from '../../../utility/HHIEButton';
import { POCEmailChangeModal } from './POCEmailChangeModal';

export function DobEmailSection(props) {
    const [dob, setDob] = useState();
    const [email, setEmail] = useState(props.member.email);
    const [showPOCEmailModal, setShowPOCEMailModal] = useState(false);
    const [pocCanChangeEmail, setPocCanChangeEmail] = useState(true);
    const [validDateRange, setValidDateRange] = useState(false);

    useEffect(() => {
        if (props.member && props.member.dob) {
            if (
                (props.member.dob.includes("1753-01-01")) ||
                (props.member.dob.includes("0001-01-01"))) {
                //var currentDate = new Date();
                //setDob(currentDate.getFullYear() + "-" + ((currentDate.getMonth() + 1) < 10 ? "0" : "") +
                //    (currentDate.getMonth() + 1) + "-" + (currentDate.getDate() < 10 ? "0" : "") + currentDate.getDate());
                setDob(undefined);
                setValidDateRange(false);
            }
            else {
                setDob(props.member.dob.split("T")[0]);
                validDate(props.member.dob.split("T")[0])
            }

        }
        if (props.member && props.member.id) {
            fetch('api/Registration/poc-email-change-requested/' + props.member.email)
                .then((response) => {
                    response.json()
                        .then((json) => {
                            if (json.errors !== null && json.errors !== "") alert(json.errors)
                            setPocCanChangeEmail(!(json.message));
                        })
                        .catch((error) => {
                            console.log("json error: " + error);
                        })
                })
                .catch((error) => {
                    console.log("Response error: " + error);
                });
        }
    }, [props])

    useEffect(() => {
        props.member.dob = dob;
        props.member.email = email;
        props.checkOkay();
    }, [dob, email])

    const validDate = (date) => {
        var today = new Date();
        var ten = new Date(today.getFullYear() - 10, 0, 0);
        var onefifty = new Date(today.getFullYear() - 150, 0, 0);
        setValidDateRange(ten > new Date(date) && onefifty < new Date(date))
    }

    const dobSetter = (value) => {
        validDate(value)
        setDob(value)
    }

    const pocEmailChangeSection = () => {
        return (
            <>
                {
                    pocCanChangeEmail ?
                        <OverlayTrigger
                            placement="bottom"
                            delay={{ show: 250, hide: 400 }}
                            overlay={<Tooltip id="legal-name-tip">
                                This email belongs to an active Point of Contact. A request must be submitted to change it.
                            </Tooltip>}>
                            <HHIEButton
                                variant="outline-primary"
                                size="sm"
                                onClick={() => {
                                    setShowPOCEMailModal(true)
                                }}
                                title="Request email change"
                            />
                        </OverlayTrigger>
                        :
                        <Alert variant="success">There is an active email change request for {props.member.email} already.</Alert>
                }
            </>
        )
    }

    return (
        <>
            <POCEmailChangeModal showModal={showPOCEmailModal} setShowModal={(value) => { setShowPOCEMailModal(value) }} member={props.member} user={props.user} />
            <Row style={{ padding: "4px" }}>
                <Col className="d-flex justify-content-end" style={{ padding: "4px" }} sm="4">
                    <div style={{ paddingRight: "5px" }}>Date of Birth</div>
                    <FormControl
                        type="date"
                        placeholder="Date of Birth"
                        value={(dob && ((!dob.includes("0001-01-01")) || (!dob.includes("1753-01-01")))) ? dob : undefined}
                        required
                        isInvalid={!dob || dob.includes("0001-01-01") || dob.includes("1753-01-01") || !validDateRange}
                        id="dob"
                        name="dob"
                        onChange={(e) => { dobSetter(e.target.value) }}
                    />
                </Col>
                <Col sm="2"></Col>
                <Col className="d-flex justify-content-end" style={{ padding: "4px" }}>
                    <div style={{ paddingRight: "5px" }}>Email Address</div>
                    {
                        !props.member.loginCapablePOC ?
                            <FormControl
                                required
                                isInvalid={!email || !(email.includes("@") && email.includes("."))}
                                type="text"
                                placeholder="Email Address"
                                defaultValue={(email) ?? undefined}
                                id="email"
                                name="email"
                                aria-label="email"
                                aria-describedby="email"
                                onChange={(e) => { setEmail(e.target.value) }}
                            />
                            :
                            pocEmailChangeSection()
                    }
                </Col>
            </Row>
        </>
    );
}